/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_NoteInputs */

const en_mk_model_note = /** @type {(inputs: Mk_Model_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost shows up per task, not just as one total invoice — cost control becomes part of the workflow, not an end-of-month report.`)
};

const id_mk_model_note = /** @type {(inputs: Mk_Model_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya tampil per tugas, bukan hanya total tagihan — kontrol biaya jadi bagian dari cara kerja, bukan laporan akhir bulan.`)
};

/**
* | output |
* | --- |
* | "Cost shows up per task, not just as one total invoice — cost control becomes part of the workflow, not an end-of-month report." |
*
* @param {Mk_Model_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_note = /** @type {((inputs?: Mk_Model_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_note(inputs)
	return en_mk_model_note(inputs)
});